import React from 'react';
import 'classlist-polyfill';
import { AnalyticsProvider } from 'use-analytics';
import { Route } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

import analytics from '~/utils/Analytics';
import { ESC_KEYCODE } from './constants';
import { elById, setupClipboard, share } from './Utils';
import GreetLandingPage from './GreetLandingPage';
import RecordingLandingPage from './RecordingLandingPage';
import TestimonialLandingPage from './TestimonialLandingPage';
import ErrorBoundaryProvider from '~/Errors/ErrorBoundaryProvider';
import { Recording } from '~/types/redux/share';
import PublishableLandingPage from './Publishable';
import { ReactQueryDevtools } from 'react-query/devtools';
import { hideIntercomPopup } from '~/utils/IntercomPopup';
import { initServiceWorker } from '~/utils/serviceWorker';
import { createRoot } from 'react-dom/client';
import { QueryClientWrapper } from '~/App/Provider/QueryClientWrapper';

void analytics.page(
  {},
  {
    plugins: {
      amplitude: false,
    },
  }
);

analytics.once('ready:intercom', () => {
  hideIntercomPopup();
});

function hideSharingModal() {
  const sharingModal = elById('sharing-modal');
  sharingModal?.classList.remove('in');

  setTimeout(() => {
    sharingModal?.classList.add('fade');
  }, 100);
}

function initShareModal() {
  setupClipboard('#url-copy-button', 'URL copied!');
  setupClipboard('#iframe-copy-button', 'Embed code copied!');

  document.body.addEventListener('keyup', (e) => {
    if (e.keyCode === ESC_KEYCODE) {
      hideSharingModal();
    }
  });

  elById('sharing-close')?.addEventListener('click', hideSharingModal);

  const shareList: HTMLElement[] = [].slice?.call(
    document.querySelector('.sharing-content')?.children ?? {}
  );
  shareList.forEach((shareItem) => {
    const platform = shareItem.children[0].getAttribute(
      'data-platform'
    ) as string;

    shareItem.onclick = () => share(platform);
  });
}

function renderReactRoutes() {
  const clientArgs = {
    defaultOptions: {
      mutations: {
        useErrorBoundary: false,
      },
    },
  };

  const element = elById('box-container');
  const root = createRoot(element!);

  if (!element) return null;

  root.render(
    <ErrorBoundaryProvider>
      <QueryClientWrapper clientArgs={clientArgs}>
        <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
        <AnalyticsProvider instance={analytics}>
          <BrowserRouter>
            <Route path='/g/:slug' component={GreetLandingPage} />
            <Route
              path='/message-template/:messageTemplate/preview'
              component={() => <GreetLandingPage hideReport />}
            />
            <Route
              path='/r/:slug'
              component={() => (
                <RecordingLandingPage
                  recording={config.model as Recording}
                  messageTemplate={config.messageTemplate}
                />
              )}
            />
            <Route
              path='/te/:name/:id'
              component={() => <TestimonialLandingPage />}
            />
            <Route
              path='/pe/:id'
              component={() => <PublishableLandingPage />}
            />
          </BrowserRouter>
        </AnalyticsProvider>
      </QueryClientWrapper>
    </ErrorBoundaryProvider>
  );
}

document.addEventListener('DOMContentLoaded', () => {
  renderReactRoutes();
  initShareModal();
});

initServiceWorker();
